import React, { FunctionComponent } from "react";
import { Grid, Box, styled } from "@mui/material";
import { PORTAL } from "@ducks/config";

interface ILoadingDetailsProps {
  length?: number;
}

const VendorTextMask = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 0,
  width: "40%",
  height: 16,
  backgroundColor: theme.palette.background.paper,
}));

const Vendor = styled("div")(({ theme }) => ({
  position: "absolute",
  right: 0,
  width: "calc(100% - 4rem)",
  height: 7,
  backgroundColor: theme.palette.background.paper,
}));

const Avatar = styled("div")(({ theme }) => ({
  position: "relative",
  width: "3rem",
  "&::after": {
    position: "absolute",
    width: "1rem",
    height: "3rem",
    left: "3rem",
    content: "''",
    top: 0,
    backgroundColor: theme.palette.background.paper,
  },
}));

const AnimatedBox = styled("div")(({ theme }) => ({
  "@keyframes placeholderShimmer": {
    "0%": {
      backgroundPosition: "top left",
    },
    "100%": {
      backgroundPosition: "top right",
    },
  },
  position: "relative",
  background:
    "linear-gradient(to right, #f3f3f3 0%, #eee 30%, #eee 50%, #f3f3f3 100%)",
  backgroundColor: "#f3f3f3",
  animation: "placeholderShimmer 2s linear 0s infinite alternate forwards",
  animationName: "$placeholderShimmer",
  backgroundPosition: "0 0",
  backgroundRepeat: "no-repeat",
  backgroundSize: " 150px 100%",
  borderRadius: theme.shape.borderRadius,
}));

const Header = styled("div")({
  position: "relative",
  paddingBottom: 33,
  width: "100%",
  height: 0,
});

const TextSpace = styled("div")({
  position: "relative",
  width: "100%",
  height: 0,
  paddingBottom: 16,
  backgroundColor: "white",
  "&::before, &::after": {
    position: "absolute",
    width: "1rem",
    height: 16,
    content: "''",
  },
});

const TextBlock1 = styled("div")({
  height: 24,
  width: "100%",
  position: "relative",
});

const TextBlock2 = styled("div")({
  height: 48,
  width: "100%",
  position: "relative",
  "&::before": {
    content: "''",
    height: 5,
    backgroundColor: "white",
    position: "absolute",
    width: "100%",
    top: 23,
  },
});

const Attribute = styled("div")({
  height: 80,
  width: "100%",
  position: "relative",
  "&::before, &::after": {
    content: "''",
    height: 5,
    backgroundColor: "white",
    position: "absolute",
    width: "100%",
  },
  "&::before": {
    top: "calc(1/3 * 80px)",
  },
  "&::after": {
    top: "calc(2/3 * 80px)",
  },
});

const AvatarImage = styled("div")({
  width: "3rem",
  height: "3rem",
});

const LoadingDetails: FunctionComponent<ILoadingDetailsProps> = () => {
  return (
    <Grid
      container
      spacing={0}
      justifyContent="center"
      data-testid="loadingDetails"
    >
      {PORTAL === "promotions" && (
        <Box sx={{ py: 0, width: "100%" }}>
          <Grid item xs={12} md={10}>
            <AnimatedBox>
              <Box sx={{ position: "relative", my: 2 }}>
                <TextBlock1 />
              </Box>
            </AnimatedBox>
          </Grid>
        </Box>
      )}

      <Grid item xs={12} md={12}>
        <AnimatedBox>
          <Box sx={{ width: "100%", height: 0, paddingBottom: "56.25%" }} />
        </AnimatedBox>
      </Grid>

      <Box sx={{ py: 2, width: "100%" }}>
        <Grid item xs={12} md={12}>
          <AnimatedBox>
            <Box sx={{ position: "relative", mb: 2 }}>
              <Avatar>
                <AvatarImage>
                  <svg viewBox="0 0 10 10" fill="#fff">
                    <path d="M0 0h10v10H0V0zm0 5c0 2.76142375 2.23857625 5 5 5s5-2.23857625 5-5-2.23857625-5-5-5-5 2.23857625-5 5z" />
                  </svg>
                </AvatarImage>
              </Avatar>
              <Vendor style={{ top: 0 }} />
              <VendorTextMask style={{ top: 7 }} />
              <Vendor style={{ top: 23, height: 4 }} />
              <VendorTextMask style={{ top: 27, width: "30%", height: 14 }} />
              <Vendor style={{ bottom: 0 }} />
            </Box>
          </AnimatedBox>
        </Grid>

        <Grid item xs={12} md={12}>
          <AnimatedBox>
            <Box sx={{ position: "relative", my: 2 }}>
              <Header />
              <TextSpace />
              <TextBlock2 />
            </Box>
          </AnimatedBox>
        </Grid>

        <Grid container spacing={0} justifyContent="flex-start">
          <Grid item xs={12} md={6}>
            <AnimatedBox>
              <Box sx={{ position: "relative", my: 2 }}>
                <Attribute />
              </Box>
            </AnimatedBox>
          </Grid>
        </Grid>

        <Grid item xs={5} md={3}>
          <AnimatedBox>
            <Box sx={{ position: "relative", my: 2 }}>
              <TextBlock1 />
            </Box>
          </AnimatedBox>
        </Grid>

        <Grid item xs={12} md={12}>
          <AnimatedBox>
            <Box sx={{ position: "relative", my: 2 }}>
              <TextBlock2 />
              <TextSpace />
              <TextBlock2 />
              <TextSpace />
              <TextBlock2 />
            </Box>
          </AnimatedBox>
        </Grid>
      </Box>
    </Grid>
  );
};

export default LoadingDetails;
